import styled, { css } from 'styled-components';

export const Content = styled.div`
  position: relative;
  padding-left: 8px;
  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      padding-left: 0;
    `}
`;
